/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Measuringpoint
 */
export interface Measuringpoint {
  /**
   *
   * @type {string}
   * @memberof Measuringpoint
   */
  readonly uuid?: string;
  /**
   *
   * @type {string}
   * @memberof Measuringpoint
   */
  readonly gmwUuid?: string;
  /**
   *
   * @type {string}
   * @memberof Measuringpoint
   */
  readonly monitoringtubeUuid?: string;
  /**
   *
   * @type {string}
   * @memberof Measuringpoint
   */
  readonly location?: string;
  /**
   *
   * @type {MeasuringpointEventTypeEnum}
   * @memberof Measuringpoint
   */
  eventType: MeasuringpointEventTypeEnum | null;
  /**
   *
   * @type {string}
   * @memberof Measuringpoint
   */
  measuringpointCode: string;
  /**
   *
   * @type {Date}
   * @memberof Measuringpoint
   */
  measuringpointStartDate: Date | null;
  /**
   *
   * @type {Date}
   * @memberof Measuringpoint
   */
  measuringpointEndDate: Date | null;
  /**
   *
   * @type {string}
   * @memberof Measuringpoint
   */
  gmwBroId: string;
  /**
   *
   * @type {string}
   * @memberof Measuringpoint
   */
  tubeNumber: string;
  /**
   *
   * @type {Date}
   * @memberof Measuringpoint
   */
  tubeStartDate: Date | null;
  /**
   *
   * @type {Date}
   * @memberof Measuringpoint
   */
  tubeEndDate: Date | null;
  /**
   *
   * @type {Date}
   * @memberof Measuringpoint
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof Measuringpoint
   */
  readonly updated?: Date;
  /**
   *
   * @type {string}
   * @memberof Measuringpoint
   */
  gmn: string;
  /**
   *
   * @type {string}
   * @memberof Measuringpoint
   */
  monitoringTube: string | null;
  /**
   *
   * @type {string}
   * @memberof Measuringpoint
   */
  dataOwner: string;
}

/**
 * @export
 */
export const MeasuringpointEventTypeEnum = {
  GmnMeasuringPoint: "GMN_MeasuringPoint",
  GmnTubeReference: "GMN_TubeReference",
  GmnMeasuringPointEndDate: "GMN_MeasuringPointEndDate",
  GmnStartRegistration: "GMN_StartRegistration",
} as const;
export type MeasuringpointEventTypeEnum =
  (typeof MeasuringpointEventTypeEnum)[keyof typeof MeasuringpointEventTypeEnum];

/**
 * Check if a given object implements the Measuringpoint interface.
 */
export function instanceOfMeasuringpoint(value: object): value is Measuringpoint {
  if (
    (!("eventType" in (value as Record<string, any>)) &&
      !("event_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["eventType"] === undefined &&
      (value as Record<string, any>)["event_type"] === undefined)
  )
    return false;
  if (
    (!("measuringpointCode" in (value as Record<string, any>)) &&
      !("measuringpoint_code" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["measuringpointCode"] === undefined &&
      (value as Record<string, any>)["measuringpoint_code"] === undefined)
  )
    return false;
  if (
    (!("measuringpointStartDate" in (value as Record<string, any>)) &&
      !("measuringpoint_start_date" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["measuringpointStartDate"] === undefined &&
      (value as Record<string, any>)["measuringpoint_start_date"] === undefined)
  )
    return false;
  if (
    (!("measuringpointEndDate" in (value as Record<string, any>)) &&
      !("measuringpoint_end_date" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["measuringpointEndDate"] === undefined &&
      (value as Record<string, any>)["measuringpoint_end_date"] === undefined)
  )
    return false;
  if (
    (!("gmwBroId" in (value as Record<string, any>)) &&
      !("gmw_bro_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["gmwBroId"] === undefined &&
      (value as Record<string, any>)["gmw_bro_id"] === undefined)
  )
    return false;
  if (
    (!("tubeNumber" in (value as Record<string, any>)) &&
      !("tube_number" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["tubeNumber"] === undefined &&
      (value as Record<string, any>)["tube_number"] === undefined)
  )
    return false;
  if (
    (!("tubeStartDate" in (value as Record<string, any>)) &&
      !("tube_start_date" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["tubeStartDate"] === undefined &&
      (value as Record<string, any>)["tube_start_date"] === undefined)
  )
    return false;
  if (
    (!("tubeEndDate" in (value as Record<string, any>)) &&
      !("tube_end_date" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["tubeEndDate"] === undefined &&
      (value as Record<string, any>)["tube_end_date"] === undefined)
  )
    return false;
  if (!("gmn" in value) || value["gmn"] === undefined) return false;
  if (
    (!("monitoringTube" in (value as Record<string, any>)) &&
      !("monitoring_tube" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["monitoringTube"] === undefined &&
      (value as Record<string, any>)["monitoring_tube"] === undefined)
  )
    return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function MeasuringpointFromJSON(json: any): Measuringpoint {
  return MeasuringpointFromJSONTyped(json, false);
}

export function MeasuringpointFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Measuringpoint {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    gmwUuid: json["gmw_uuid"] == null ? undefined : json["gmw_uuid"],
    monitoringtubeUuid:
      json["monitoringtube_uuid"] == null ? undefined : json["monitoringtube_uuid"],
    location: json["location"] == null ? undefined : json["location"],
    eventType: json["event_type"],
    measuringpointCode: json["measuringpoint_code"],
    measuringpointStartDate:
      json["measuringpoint_start_date"] == null
        ? null
        : new Date(json["measuringpoint_start_date"]),
    measuringpointEndDate:
      json["measuringpoint_end_date"] == null ? null : new Date(json["measuringpoint_end_date"]),
    gmwBroId: json["gmw_bro_id"],
    tubeNumber: json["tube_number"],
    tubeStartDate: json["tube_start_date"] == null ? null : new Date(json["tube_start_date"]),
    tubeEndDate: json["tube_end_date"] == null ? null : new Date(json["tube_end_date"]),
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    gmn: json["gmn"],
    monitoringTube: json["monitoring_tube"],
    dataOwner: json["data_owner"],
  };
}

export function MeasuringpointToJSON(json: any): Measuringpoint {
  return MeasuringpointToJSONTyped(json, false);
}

export function MeasuringpointToJSONTyped(
  value?: Omit<
    Measuringpoint,
    "uuid" | "gmw_uuid" | "monitoringtube_uuid" | "location" | "created" | "updated"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    event_type: value["eventType"],
    measuringpoint_code: value["measuringpointCode"],
    measuringpoint_start_date:
      value["measuringpointStartDate"] == null
        ? value["measuringpointStartDate"]
        : value["measuringpointStartDate"].toISOString().substring(0, 10),
    measuringpoint_end_date:
      value["measuringpointEndDate"] == null
        ? value["measuringpointEndDate"]
        : value["measuringpointEndDate"].toISOString().substring(0, 10),
    gmw_bro_id: value["gmwBroId"],
    tube_number: value["tubeNumber"],
    tube_start_date:
      value["tubeStartDate"] == null
        ? value["tubeStartDate"]
        : value["tubeStartDate"].toISOString().substring(0, 10),
    tube_end_date:
      value["tubeEndDate"] == null
        ? value["tubeEndDate"]
        : value["tubeEndDate"].toISOString().substring(0, 10),
    gmn: value["gmn"],
    monitoring_tube: value["monitoringTube"],
    data_owner: value["dataOwner"],
  };
}
